export default {
  title: 'Request a Win',
  fare_board_title: 'Fare Board',
  fare_board_not_set: 'Fare board not set',
  request_button: 'เรียกวิน',
  cancel_button: 'Cancel request',
  status: {
    pending: 'Waiting for a Win...',
    accepted: 'มีวินรับงานแล้ว ✅',
    expired: 'ยังไม่มีวินรับงาน',
    cancelled: 'Request cancelled',
  },
  poll_note: 'We will notify you when a Win accepts the request. This will expire after 10 minutes.',
  module_disabled: 'Win pickup service is not available.',
  errors: {
    create_failed: 'Could not submit request. Please try again.',
    already_pending: 'You already have a pending request.',
    cancel_failed: 'Could not cancel request. Please try again.',
    load_failed: 'Could not load fare board.',
    no_active_lease: 'No active lease found for this unit.',
  },
}
